// removed by extract-text-webpack-plugin
module.exports = {"component":"_aapRH3r9AEqaz_8O1Eq4","pageTopTitle":"_3MmAOUwZZEhBANnCJ9uUEv","title":"_2KMJfk6h4vSnrrzJDzozNT","radio":"_3iPyZJxUXhZDzzc1IsO8N4","payPlatform":"_74x3JU6w_DAjEX8YNo_1n","payPlatformUl":"_32Q9ysSEklQML4-L-Q-CcW","queryOrderBtn":"_1b5N_FI65Zzrz2m_SR2S3A"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PaymentContent/PaymentContent.scss
 ** module id = 1006
 ** module chunks = 0
 **/